// Seules ces trois valeurs sont valides. Une valeur persistée héritée d'une
// ancienne version (null, 0, "", nombre…) doit retomber sur le défaut sûr
// `true` (= consentement non donné) : sinon une valeur falsy ≠ false afficherait
// le contenu (Blocks teste la véracité) alors que le toggle et RawHtml la
// considèrent « non acceptée » (=== false) → état incohérent (toggle OFF mais
// contenu affiché). Le défaut de paramètre `= true` ne couvre que `undefined`.
const isValidChoice = value =>
	value === true || value === false || value === 'refused'

const cookiebox = (state = true, action) => {
	switch (action.type) {
		case 'CLOSE_COOKIE_BOX':
			return false
		case 'SHOW_COOKIE_BOX':
			return true
		case 'REFUSED_COOKIE_BOX':
			return 'refused'
		default:
			return isValidChoice(state) ? state : true
	}
}

export default cookiebox

export const getCookiebox = state => state.cookiebox
